// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"PaymentUpdatedModal_modalContainer__3MM_k","headerText":"PaymentUpdatedModal_headerText__a30eQ"};